const House = () => {
    return (
      <div>
        <h1>House</h1>
        {/* Content goes here */}
      </div>
    );
};

export default House;